
export function isMenuItemActive(currentPath: string, menuPath: string): boolean {
    if (currentPath === menuPath) {
        return true;
    }
    if (menuPath !== '/' && currentPath.startsWith(menuPath)) {
        const nextChar = currentPath.charAt(menuPath.length);
        return nextChar === '/' || nextChar === ''|| nextChar === '?' || nextChar === '#';
    }

    return false;
}
